import { asset } from "./lib/supabase";
const dbsLogo = asset("dbs-logo-red.webp");
const dbsCover = asset("dbs-cover.webp");
const sikaramCover = asset("sikaram-cover.webp");
const sikaramLogo = asset("sikaram-groundnut.webp");
const unitedMonkeysLogo = asset("united-monkeys.webp");
const tnGovCover = asset("tngov-cover.webp");
const nagaCover = asset("naga-cover.webp");
const barberCover = asset("baber-cover.webp");
const brandAdsCover = asset("02_cover.webp");
const aiFilmsCover = asset("01_cover.webp");
const productCover = asset("04_cover.webp");
const reelsCover = asset("03_cover.webp");
const premiumCover = asset("Premium_cover.webp");
// Food Images
const food1 = asset("food/Vision_Slow-motion_shot_of_fresh_lettuce_leaves_tomato_slices_a_3cb35dac-3219-4be1-902e-38e249c5002a.webp");
const food2 = asset("food/aliia_43348_Ultra-realistic_cinematic_food_still_life_slow_livi_6101e38a-b64a-44d6-ab33-212e19c43cbe.webp");
const food3 = asset("food/bystrov_ultra-realistic_slice_of_lemon_cheesecake_on_a_dark_cer_031b732d-c6e9-45fd-aeec-22818d89b85e.webp");
const food4 = asset("food/pochogarces_42850_carne_camaron_sin_piel_y_pollo_servidos_con_P_4f29a9d3-5c30-4dba-a73e-d1debf6c6d06.webp");
const food5 = asset("food/u6327859332_moody_editorial_food_photograph_of_a_small_chocolat_5ea13a03-90f6-4516-bd06-7852cfc4f82c.webp");
const food6 = asset("food/u7699393795_a_hyperrealistic_macro_food_art_scene_showing_a_sta_f6bc7147-3fbf-4ef5-a5d3-9aaecbe2943c.webp");
// Jewel Images
const jewel1 = asset("jewel/pangajourney_Elegant_jewelry_photography_featuring_three_differ_9caa1657-ad6d-420b-9742-01d9797d971b.webp");
const jewel2 = asset("jewel/ramitgempundit_A_voilet_oval_Amethyst_set_in_Sliver_surrounded__208e45c8-b85e-48b4-808a-48fb20919850.webp");
export const MEDIA = {
  heroAd: "https://images.pexels.com/photos/17865442/pexels-photo-17865442.jpeg",
  heroBg:
    asset("hero-cinema-screen.webp"),
  heroVimeoId: "1198956646",
  heroLabel: "Now Showing — DBS Bank Brand Film",
};

export const services = [
  {
    id: "ai-short-films-series",
    index: "01",
    title: "AI Short Films & Series",
    short: "AI Films",
    subtitle: "Identity & Art Direction",
    type: "Video",
    unit: "Films",
    image: aiFilmsCover,
    gallery: [
      {
        src: barberCover,
        caption: "Barber",
        isVideo: true,
        embed_url: "https://player.vimeo.com/video/1198956649",
        provider: "vimeo",
      },
      {
        src: nagaCover,
        caption: "Nagadosam",
        isVideo: true,
        embed_url: "https://player.vimeo.com/video/1198956647",
        provider: "vimeo",
      },
      {
        src: "https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw1fHxhYnN0cmFjdCUyMGZsb3dlciUyMGZpcmV8ZW58MHx8fHwxNzgwNjc1MDU2fDA&ixlib=rb-4.1.0&q=85",
        caption: "Flower and Fire",
        isVideo: true,
        embed_url: "https://player.vimeo.com/video/1199276699",
        provider: "vimeo",
      },
      {
        src: "https://images.unsplash.com/photo-1509281373149-e957c6296406?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxteXN0ZXJpb3VzJTIwd29tYW4lMjBzaWxob3VldHRlJTIwaW4lMjBtaXN0fGVufDB8fHx8MTc4MDY3NTA1Nnww&ixlib=rb-4.1.0&q=85",
        caption: "I Find Her",
        isVideo: true,
        embed_url: "https://player.vimeo.com/video/1199276698",
        provider: "vimeo",
      },
    ],
  },
  {
    id: "brand-advertisements",
    index: "02",
    title: "Brand Advertisements",
    short: "Brand Ads",
    subtitle: "Cinematic Commercials",
    type: "Video",
    unit: "Films",
    image: brandAdsCover,
    gallery: [
      { src: "https://images.pexels.com/photos/17865442/pexels-photo-17865442.jpeg", caption: "DBS Brand Film" },
      {
        src: "https://images.unsplash.com/photo-1774175383227-b6baab7ab035?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxjaW5lbWF0aWMlMjBsdXh1cnklMjBjb21tZXJjaWFsJTIwZmFzaGlvbnxlbnwwfHx8fDE3ODA2NzUwNTZ8MA&ixlib=rb-4.1.0&q=85",
        caption: "Retail Launch",
      },
      {
        src: "https://images.unsplash.com/photo-1551113006-731674fbb3ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxjaW5lbWF0aWMlMjBsdXh1cnklMjBjb21tZXJjaWFsJTIwZmFzaGlvbnxlbnwwfHx8fDE3ODA2NzUwNTZ8MA&ixlib=rb-4.1.0&q=85",
        caption: "Premium Film",
      },
      {
        src: "https://images.unsplash.com/photo-1742218410117-579424ae809e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxjaW5lbWF0aWMlMjBsdXh1cnklMjBjb21tZXJjaWFsJTIwZmFzaGlvbnxlbnwwfHx8fDE3ODA2NzUwNTZ8MA&ixlib=rb-4.1.0&q=85",
        caption: "Fashion Commercial",
      },
    ],
  },
  {
    id: "reels-short-form",
    index: "03",
    title: "Reels & Short-Form Content",
    short: "Reels & Shorts",
    subtitle: "Social Content",
    type: "Video",
    unit: "Reels",
    image: reelsCover,
    gallery: [
      { src: "https://images.pexels.com/photos/16059406/pexels-photo-16059406.jpeg", caption: "Editorial Reel" },
      { src: "https://images.pexels.com/photos/28446156/pexels-photo-28446156.jpeg", caption: "Food Short-Form" },
      {
        src: "https://images.unsplash.com/photo-1570733117311-d990c3816c47?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBsdXh1cnklMjBjb21tZXJjaWFsJTIwZmFzaGlvbnxlbnwwfHx8fDE3ODA2NzUwNTZ8MA&ixlib=rb-4.1.0&q=85",
        caption: "Lifestyle Reel",
      },
      { src: "https://images.pexels.com/photos/8112891/pexels-photo-8112891.jpeg", caption: "Restaurant Reel" },
    ],
  },
  {
    id: "product-photography",
    index: "04",
    title: "Product Photography",
    short: "Product Photos",
    subtitle: "Still Life & Product",
    type: "Photo",
    unit: "Photos",
    image: productCover,
    gallery: [
      {
        src: asset("product/advertising-composition.webp"),
        caption: "Premium Hair Wash",
        category: "product",
      },
      {
        src: asset("product/product-shot.webp"),
        caption: "Body Lotion",
        category: "product",
      },
      {
        src: asset("product/sticker-brand.webp"),
        caption: "Ultra Premium Serum",
        category: "product",
      },
      {
        src: "https://images.unsplash.com/photo-1611930021592-a8cfd5319ceb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxtaW5pbWFsaXN0JTIwcHJvZHVjdCUyMHBob3RvZ3JhcGh5fGVufDB8fHx8MTc4MDY3NTA1Nnww&ixlib=rb-4.1.0&q=85",
        caption: "Luxury Packaging",
        category: "product",
      },
      {
        src: "https://images.unsplash.com/photo-1611930022073-b7a4ba5fcccd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwcHJvZHVjdCUyMHBob3RvZ3JhcGh5fGVufDB8fHx8MTc4MDY3NTA1Nnww&ixlib=rb-4.1.0&q=85",
        caption: "Minimal Identity",
        category: "product",
      },
      {
        src: "https://images.unsplash.com/photo-1655657874630-2da5679ef515?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0JTIwcHJvZHVjdCUyMHBob3RvZ3JhcGh5fGVufDB8fHx8MTc4MDY3NTA1Nnww&ixlib=rb-4.1.0&q=85",
        caption: "Art Direction",
        category: "product",
      },
      {
        src: food1,
        caption: "Moody Salad Shoot",
        category: "food",
      },
      {
        src: food2,
        caption: "Gourmet Pasta",
        category: "food",
      },
      {
        src: food3,
        caption: "Lemon Cheesecake",
        category: "food",
      },
      {
        src: food4,
        caption: "Asador Skewers",
        category: "food",
      },
      {
        src: food5,
        caption: "Chocolate Soufflé",
        category: "food",
      },
      {
        src: food6,
        caption: "Hyperrealistic Burger",
        category: "food",
      },
      {
        src: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxmb29kfGVufDB8fHx8MTc4MDY3NTA1Nnww&ixlib=rb-4.1.0&q=85",
        caption: "Gourmet Bowl",
        category: "food",
      },
      {
        src: jewel1,
        caption: "Luxury Necklaces Trio",
        category: "jewel",
      },
      {
        src: jewel2,
        caption: "Oval Amethyst Ring",
        category: "jewel",
      },
      {
        src: "https://images.unsplash.com/photo-1599643478524-fb66f70d00f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxqZXdlbHJ5fGVufDB8fHx8MTc4MDY3NTA1Nnww&ixlib=rb-4.1.0&q=85",
        caption: "Golden Jewelry Set",
        category: "jewel",
      },
      {
        src: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxqZXdlbHJ5fGVufDB8fHx8MTc4MDY3NTA1Nnww&ixlib=rb-4.1.0&q=85",
        caption: "Fine Gold Necklace",
        category: "jewel",
      },
      {
        src: "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxkaWFtb25kfGVufDB8fHx8MTc4MDY3NTA1Nnww&ixlib=rb-4.1.0&q=85",
        caption: "Diamond Cut Detail",
        category: "jewel",
      },
      {
        src: "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxkaWFtb25kfGVufDB8fHx8MTc4MDY3NTA1Nnww&ixlib=rb-4.1.0&q=85",
        caption: "Engagement Ring Set",
        category: "jewel",
      },
      {
        src: "https://images.unsplash.com/photo-1605100804763-247f67b2548e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxyaW5nfGVufDB8fHx8MTc4MDY3NTA1Nnww&ixlib=rb-4.1.0&q=85",
        caption: "Solitaire Diamond Ring",
        category: "jewel",
      },
    ],
  },
];

export const projects = [
  {
    id: "dbs-bank",
    title: "DBS Bank Brand Film",
    subtitle: "Singapore · Finance",
    category: "Brand Film",
    type: "Video",
    vimeoId: "1198956646",
    image: dbsCover,
    logo: dbsLogo,
    logoSize: "h-8 md:h-10",
    span: "sm:col-span-2 lg:col-span-8",
    aspect: "aspect-[16/10]",
    featured: true,
    stats: [
      { value: "+2M", label: "Reach" },
      { value: "+300%", label: "Engagement" },
      { value: "0:90", label: "Runtime" },
    ],
  },
  {
    id: "sikaram-pongal",
    title: "Sikaram — Pongal Film",
    subtitle: "Pongal · FMCG\nClient: United Monkeys",
    category: "Brand Film",
    type: "Video",
    vimeoId: "1198956698",
    image: sikaramCover,
    imageClass: "object-[-8px_center]",
    flipImage: true,
    logo: sikaramLogo,
    logoSize: "h-5 md:h-6",
    clientLogo: unitedMonkeysLogo,
    clientLogoSize: "h-7 md:h-8",
    span: "sm:col-span-2 lg:col-span-4",
    aspect: "aspect-[4/5]",
    featured: true,
    stats: [
      { value: "+4M", label: "Views" },
      { value: "18K", label: "Shares" },
      { value: "1:20", label: "Runtime" },
    ],
  },
  {
    id: "tn-govt",
    title: "Tamil Nadu Govt Ad",
    subtitle: "Public Campaign",
    category: "Film",
    type: "Video",
    vimeoId: "1198956650",
    image: tnGovCover,
    imageStyle: { objectPosition: "calc(50% - 16px) center" },
    span: "sm:col-span-1 lg:col-span-4",
    aspect: "aspect-[4/5]",
    featured: false,
  },
  {
    id: "nagadosam-ai",
    title: "Nagadosam — AI Promo",
    subtitle: "AI Film · Promo",
    category: "AI Film",
    type: "Video",
    vimeoId: "1198956647",
    image: nagaCover,
    imageStyle: { objectPosition: "calc(50% - 16px) center" },
    span: "sm:col-span-1 lg:col-span-4",
    aspect: "aspect-[4/5]",
    featured: false,
  },
  {
    id: "barber-ai",
    title: "Barber — AI Promo",
    subtitle: "AI Film · Promo",
    category: "AI Film",
    type: "Video",
    vimeoId: "1198956649",
    image: barberCover,
    span: "sm:col-span-1 lg:col-span-4",
    aspect: "aspect-[4/5]",
    featured: false,
  },
  {
    id: "flower-and-fire",
    title: "Flower and Fire",
    subtitle: "AI Film · Cinematic",
    category: "AI Film",
    type: "Video",
    vimeoId: "1199276699",
    image: "https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw1fHxhYnN0cmFjdCUyMGZsb3dlciUyMGZpcmV8ZW58MHx8fHwxNzgwNjc1MDU2fDA&ixlib=rb-4.1.0&q=85",
    span: "sm:col-span-1 lg:col-span-4",
    aspect: "aspect-[4/5]",
    featured: false,
  },
  {
    id: "i-find-her",
    title: "I Find Her",
    subtitle: "AI Film · Cinematic",
    category: "AI Film",
    type: "Video",
    vimeoId: "1199276698",
    image: "https://images.unsplash.com/photo-1509281373149-e957c6296406?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxteXN0ZXJpb3VzJTIwd29tYW4lMjBzaWxob3VldHRlJTIwaW4lMjBtaXN0fGVufDB8fHx8MTc4MDY3NTA1Nnww&ixlib=rb-4.1.0&q=85",
    span: "sm:col-span-1 lg:col-span-4",
    aspect: "aspect-[4/5]",
    featured: false,
  },
];

export const caseStudies = [
  {
    id: "premium-brand-film",
    title: "Premium Brand Film",
    type: "Video",
    description:
      "A flagship brand film built around a single, unforgettable moment — directed, shot and scored in-house.",
    image: premiumCover,
  },
  {
    id: "luxury-product-shoot",
    title: "Luxury Product Shoot",
    type: "Photo",
    description:
      "A considered still-life series for a premium house — sculpted light, immaculate surfaces, zero noise.",
    image:
      asset("product/advertising-composition.webp"),
  },
  {
    id: "short-form-campaign",
    title: "Shorts Content",
    type: "Video",
    description:
      "A high-velocity reels campaign tuned for the feed — designed to be felt before it is understood.",
    image: "https://images.pexels.com/photos/28446156/pexels-photo-28446156.jpeg",
  },
];

export const stats = [
  { value: "15+", label: "Projects Completed" },
  { value: "10M+", label: "Views Generated" },
  { value: "100+", label: "Creative Assets Delivered" },
  { value: "10+", label: "Brands Served" },
];

export const processSteps = [
  { index: "01", title: "Discover", description: "Understand the brand." },
  { index: "02", title: "Create", description: "Develop creative concepts." },
  { index: "03", title: "Refine", description: "Perfect every detail." },
  { index: "04", title: "Launch", description: "Deliver and scale." },
];

export const testimonials = [
  {
    quote:
      "They understood our brand better than we did. The film they delivered felt timeless from the first frame.",
    name: "Elena Marchetti",
    role: "Creative Director, Maison Vela",
  },
  {
    quote:
      "Every detail was considered. The product photography elevated how customers perceive our entire range.",
    name: "Daniel Cho",
    role: "Founder, Aureo",
  },
  {
    quote:
      "Our short-form content finally feels like us — restrained, premium and impossible to scroll past.",
    name: "Priya Nair",
    role: "Head of Marketing, Lumière",
  },
];
